import { render, staticRenderFns } from "./PinIcon.vue?vue&type=template&id=08116a51&scoped=true&"
import script from "./PinIcon.vue?vue&type=script&lang=js&"
export * from "./PinIcon.vue?vue&type=script&lang=js&"
import style0 from "./PinIcon.vue?vue&type=style&index=0&id=08116a51&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08116a51",
  null
  
)

export default component.exports